import { Children } from 'react';

const getChildInstanceOf = (Child, children) =>
  // @ts-ignore TS(2339): Property 'type' does not exist on type 'string | n... Remove this comment to see the full error message
  Children.toArray(children).find(({ type }) => type === Child);

export default getChildInstanceOf;
